export default {"src":"/_next/static/image/public/images/ic_down_arrow_black.54c1d974c1886fc88116a91cf6ac0159.svg","height":16,"width":16};